<script lang="ts" setup>
// Big buttons to choose the department the worker is shooting for. Only their allowed ones show.

const props = defineProps<{
  allowed: FieldDepartment[]
  current?: FieldDepartment | null
  loading?: boolean
}>()
const emit = defineEmits<{ choose: [department: FieldDepartment] }>()

const ICONS: Record<FieldDepartment, string> = {
  mitigation: 'pi-cloud',
  recon: 'pi-hammer',
  packout: 'pi-box',
}
// A function so the hints follow the language switch.
const hint = (department: FieldDepartment) =>
  ({
    mitigation: ft('Water, fire and mold damage'),
    recon: ft('Rebuild and repairs'),
    packout: ft('Contents and moving'),
  })[department]

const options = computed(() =>
  FIELD_DEPARTMENTS.filter((item) => props.allowed.includes(item.value))
)
</script>

<template>
  <div
    class="field-departments"
    role="radiogroup"
    :aria-label="ft('Department')"
  >
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      role="radio"
      class="field-department"
      :class="[
        `is-${option.value}`,
        { 'is-current': option.value === current },
      ]"
      :aria-checked="option.value === current"
      :disabled="loading"
      @click="emit('choose', option.value)"
    >
      <i class="pi" :class="ICONS[option.value]" aria-hidden="true" />
      <span>
        <strong>{{ departmentLabel(option.value) }}</strong>
        <small>{{ hint(option.value) }}</small>
      </span>
      <i
        v-if="option.value === current"
        class="pi pi-check-circle"
        aria-hidden="true"
      />
    </button>
  </div>
</template>
